import data from "@/mixins/data";
import formable from "@/mixins/formable";
import Vue from 'vue';

import {
  UPDATE_BILLS_RESET,
  UPDATE_BILLS,
} from "@/store/bills/actions";

import {
  GET_COMPANIES_SINGLE,
} from "@/store/companies/actions";

import {
  DATA_ISO_COUNTRIES_2_LETTERS
} from "@/store/data/actions";

import bill from "@/pages/bills/mixins/bill";

import VClient from "@/components/widgets/VClient";
import Reservations from "@/pages/bills/partials/reservations/List";
import PropertyExtras from "@/pages/bills/partials/PropertyExtrasImport";
import RowDetail from "@/pages/bills/partials/RowDetail";
import revenueShare from "@/pages/bills/mixins/revenueShare";

export default {
  components: {
    VClient,
    Reservations,
    PropertyExtras,
    RowDetail,
  },
  mixins: [
    bill,
    data,
    formable,
    revenueShare
  ],
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tabs: 'tab-details',
      form: {
        date: this.$toDateString(this.$moment()),
        client_id: null,
        company_id: null,
        customer_name: null,
        customer_country: null,
        customer_state: null,
        customer_city: null,
        customer_address: null,
        customer_postcode: null,
        customer_vat_code: null,
        customer_tax_code: null,
        sdi: null,
        pec: null,
        reservation_ids: [],
        bill_details: [{}],
        payments: [],
        _options: {
          is_revenue_share: false,
          revenue_share_rule: {},
          owner_document_details: [],
        },
      },
      totals: {
        amount: 0,
        vat_amount: 0,
        net_amount: 0,
        paid_amount: 0,
        remaining_amount: 0,
      },
      billFormat: null,
      vatExclusion: {
        index: null,
        value: null,
        isOpen: false,
      },
      forceEditing: false,
      companyName: null,
      isOpenExtras: false,
      isOpenRowDetail: false,
      activeDetail: null,
      isEditCompany: false,
    };
  },
  beforeMount() {
    this.$store.dispatch(DATA_ISO_COUNTRIES_2_LETTERS);
  },
  methods: {
    resetAction() {
      return UPDATE_BILLS_RESET;
    },
    submitAction() {
      return UPDATE_BILLS;
    },
    submitActionOptions() {
      let data = {
        is_paid: false,
        ...this.form,
        ...this.totals
      };

      if (this.totals.remaining_amount == 0) {
        data.is_paid = true;
      }

      if (this.billFormat) {
        const billParts = this.billFormat.split('/');

        if (billParts[0]) {
          data.bill_n = billParts[0];
        }
        if (billParts[1]) {
          data.bill_series = billParts[1];
        }
      }

      data.payments = data.payments.filter((payment) => {
        return !this.$isEmpty(payment);
      });

      if (!data.payments.length) {
        delete data['payments'];
      }

      if (this.itemId) {
        return {
          id: this.itemId,
          params: data
        };
      }

      return data;
    },
    addDetail() {
      this.form.bill_details.push({});
    },
    removeDetail(index) {
      this.form.bill_details.splice(index, 1);
    },
    addPayment() {
      this.form.payments.push({
        date: this.$moment().format('YYYY-MM-DD'),
        type: this.$const('ConstPaymentTypes', 'CASH_IN')
      });
    },
    removePayment(index) {
      this.form.payments.splice(index, 1);
    },
    reservationsChanged(reservations) {
      if (!reservations.length) {
        return false;
      }

      this.form.bill_details = [];
      this.form.reservation_ids = [];

      this.form.currency = reservations[0].currency;

      let cityTax = 0;
      let cityTaxDescription = this.$lang('bills.labels.city_tax');

      reservations.forEach((reservation) => {
        const hasRevenueShare = !!reservation.property.revenue_share_rule;

        if (!this.itemId) {
          let billsAmount = 0;

          reservation.bills.forEach((bill) => {
            bill.bill_details.forEach((detail) => {
              if (
                detail.reservation_id === reservation.id &&
                !detail.reservation_extra_id
              ) {
                billsAmount += parseFloat(detail.amount);
              }
            });
          });

          reservation.amount -= billsAmount;
        }

        this.form.reservation_ids.push(reservation.id);
        this.setCompanyReferences(reservation);
        
        if (hasRevenueShare) {
          this.createBillDetailsWithRevenueShare(reservation)
        } else {
          let billDetail = this.createBillDetails(reservation);

          cityTax += billDetail.cityTax;

          if (!!reservation.property.city_tax_description) {
            cityTaxDescription = reservation.property.city_tax_description
          }
        }
        
      });

      if (cityTax > 0) {
        this.form.bill_details.push({
          amount: cityTax,
          vat_type: 0,
          description: cityTaxDescription,
          type: this.$const('ConstDetailRowTypes', 'CITY_TAX'),
        });
      }

      this.reservations = reservations;
      this.importPaymentsFromReservations();
    },
    createBillDetails(reservation) {
      let cityTax = 0;
      const vatType = reservation.property.vat_type.value;
      const vatExclusionIt = parseInt(vatType) === 0 ? reservation.property.vat_exclusion_it : null;
      const langResId = this.$lang('reservations.fields.res_id');
      const startDate = this.$moment(reservation.start_date).format('DD/MM');
      const endDate = this.$moment(reservation.end_date).format('DD/MM');
      const clientName = reservation.given_name ? `${reservation.given_name} ${reservation.family_name}` : reservation.client.name;

      this.form.bill_details.push({
        reservation_id: reservation.id,
        amount: parseFloat(reservation.amount).toFixed(2),
        vat_type: vatType,
        vat_exclusion_it: vatExclusionIt,
        description: `${langResId} ${reservation.res_id} - ${startDate} -> ${endDate} - ${clientName}`,
        type: this.$const('ConstDetailRowTypes', 'RESERVATION'),
      });

      if (reservation.city_tax > 0) {
        cityTax = parseFloat(reservation.city_tax);
      }

      if (reservation.cleaning_fee > 0) {
        this.form.bill_details.push({
          reservation_id: reservation.id,
          amount: reservation.cleaning_fee,
          vat_type: vatType,
          vat_exclusion_it: vatExclusionIt, 
          description: `${reservation.res_id} - ${clientName} - Cleaning Fee`,
          type: this.$const('ConstDetailRowTypes', 'CLEANING_FEE'),
        });
      }

      if (reservation.reservation_extras.length) {
        reservation.reservation_extras.forEach((extra) => {
          let vatType = parseInt(extra.vat_percent) >= 0 ? extra.vat_percent : reservation.property.vat_type.value;

          const vatPercent = parseInt(extra.vat_percent);
          const extraAmount = parseFloat(extra.amount) * parseInt(extra.quantity);
          const extraVatType = vatPercent >= 0 ? vatPercent : vatType;

          this.form.bill_details.push({
            reservation_id: reservation.id,
            amount: extraAmount,
            vat_type: extraVatType,
            vat_exclusion_it: parseInt(extraVatType) === 0 ? vatExclusionIt : null,
            reservation_extra_id: extra.id,
            description: `${reservation.res_id} - ${clientName} - ${extra.name}`,
            type: this.$const('ConstDetailRowTypes', 'EXTRA'),
          });
        });
      }

      return {
        cityTax
      }
    },
    setCompanyReferences(item) {
      if (!this.form.company_location_id && item.property.company_location_id) {
        this.form.company_location_id = item.property.company_location_id;
      }

      if (!this.form.company_journal_id && item.property.company_journal_id) {
        this.form.company_journal_id = item.property.company_journal_id;
      }
    },
    clientChanged(client) {
      if (this.itemId) {
        if (client) {
          this.form.client_id = client.id;
        }

        return false;
      }

      if (!client) {
        this.$delete(this.form, 'client_id');
        this.$delete(this.form, 'company_id');
        this.$delete(this.form, 'customer_name');
        this.$delete(this.form, 'customer_country');
        this.$delete(this.form, 'customer_state');
        this.$delete(this.form, 'customer_city');
        this.$delete(this.form, 'customer_address');
        this.$delete(this.form, 'customer_postcode');
        this.$delete(this.form, 'customer_vat_code');
        this.$delete(this.form, 'customer_tax_code');
        this.$delete(this.form, 'sdi');
      } else {
        this.form.client_id = client.id;
        this.form.company_id = client.company_id;
        this.form.customer_name = client.name;
        this.form.customer_country = client.country;
        this.form.customer_state = client.state;
        this.form.customer_city = client.city;
        this.form.customer_address = client.address;
        this.form.customer_postcode = client.postcode;
        this.form.customer_vat_code = client.vat_code;
        this.form.customer_tax_code = client.tax_code;
        this.form.sdi = client.sdi;
        this.form.pec = client.pec;

        this.setDocumentSeries();
      }

      this.$forceUpdate();
    },
    setDocumentSeries() {
      this.$store.dispatch(GET_COMPANIES_SINGLE, {
        id: this.form.company_id,
        params: {
          _data: {
            selects: [
              'id',
              'name',
            ],
            relations: {
              series: {
                selects: [
                  'company_id',
                  'n',
                  'series',
                  'type',
                  'is_default',
                  'notes',
                ],
                where: [
                  {
                    field: 'type',
                    value: this.$const('ConstCompanySeriesTypes', 'BILL')
                  }
                ]
              }
            }
          }
        }
      }).then((response) => {
        let billN = null;
        let billSeries = null;

        response.series.map((item) => {          
          if (item.is_default) {
            billN = item.n;
            billSeries = item.series;
            this.form.notes = item.notes;
          }
        });

        this.billFormat = this.$billGenerate(billN, billSeries);
        this.companyName = response.name;
      })
    },
    calculateTotals() {
      this.totals = {
        amount: 0,
        vat_amount: 0,
        net_amount: 0,
        paid_amount: 0,
        remaining_amount: 0,
      };

      this.form.bill_details.map((detail) => {
        if (detail.amount !== 0 && !detail.amount) {
          return false;
        }

        const amount = parseFloat(detail.amount);
        const percent = parseFloat(detail.vat_type || 0);
        const vatAmount = amount * percent / (percent + 100);

        let netAmount = amount - vatAmount;
        netAmount = netAmount.toFixed(6);
        netAmount = parseFloat(netAmount);

        detail.amount = amount;
        detail.vat_amount = parseFloat(vatAmount.toFixed(6));
        detail.net_amount = netAmount;

        this.totals.amount += detail.amount;
        this.totals.vat_amount += detail.vat_amount;
        this.totals.net_amount += detail.net_amount;
      });

      this.form.payments.map((payment) => {
        if (payment.amount_absolute !== 0 && !payment.amount_absolute) {
          return false;
        }

        if (payment.type === this.$const('ConstPaymentTypes', 'CASH_IN')) {
          payment.amount = parseFloat(payment.amount_absolute);
        }
        if (payment.type === this.$const('ConstPaymentTypes', 'CASH_OUT')) {
          payment.amount = -parseFloat(payment.amount_absolute);
        }

        this.totals.paid_amount += payment.amount;
      });

      this.totals.amount = this.$money(this.totals.amount);
      this.totals.vat_amount = this.$money(this.totals.vat_amount);
      this.totals.net_amount = this.$money(this.totals.net_amount);
      this.totals.paid_amount = this.$money(this.totals.paid_amount);
      this.totals.remaining_amount = this.$money(this.totals.amount - this.totals.paid_amount);
    },
    openVatExclusion(index) {
      this.vatExclusion = {
        index: null,
        value: null,
        isOpen: false,
      };

      this.vatExclusion.index = index;
      this.vatExclusion.isOpen = true;
      this.vatExclusion.value = this.form.bill_details[this.vatExclusion.index].vat_exclusion_it;
    },
    saveVatExclusion() {
      this.vatExclusion.isOpen = false;
      this.form.bill_details[this.vatExclusion.index].vat_exclusion_it = this.vatExclusion.value;
    },
    importPaymentsFromReservations() {
      if (!this.itemId) {
        this.form.payments = [];
      }

      this.reservations.map((reservation) => {
        reservation.payments.map((payment) => {
          delete payment['owner_id'];

          payment.type = payment.amount > 0 ? 'CASH_IN' : 'CASH_OUT';
          payment.type = this.$const('ConstPaymentTypes', payment.type);
          payment.amount_absolute = this.$absolute(payment.amount);
          payment.parent_id = payment.id;

          this.form.payments.push({
            ...payment,
            reservation_id: reservation.id,
            owner_type: this.$const('ConstMorphTypeAliases', 'BILL'),
          });
        });
      });

      if (!this.form.payments.length) {
        this.form.payments = [];
      }
    },
    importedPaymentWarning(payment) {
      if (!!payment.parent_id) {
        this.showNotification(this.$lang('bills.labels.edit_imported_payment'), "warning");
      }
    },
    openExtras() {
      this.isOpenExtras = true;
    },
    closeExtras() {
      this.isOpenExtras = false;
    },
    addExtra(val) {
      this.isOpenExtras = false;
      this.form.bill_details.push({
        description: val.name,
        vat_type: val.vat_percent,
        amount: val.amount
      });
    },
    canRemoveDetail(val) {
      return (
        this.form.bill_details.length > 1
        // && ((!val.reservation_id || !!val.reservation_extra_id) || val.amount === 0)
      );
    },
    openRowDetail(detail, index) {
      this.activeDetail = {
        ...detail,
        index,
      };
      this.isOpenRowDetail = true;
    },
    closeRowDetail() {
      this.isOpenRowDetail = false;
      this.activeDetail = null;
    },
    saveRowDetail(detail) {
      const index = detail.index;
      delete detail['index'];

      Vue.set(this.form.bill_details, index, detail);
      this.isOpenRowDetail = false;
    }
  },
  watch: {
    'form.payments': {
      handler() {
        this.calculateTotals();
      },
      deep: true
    },
    'form.bill_details': {
      handler() {
        this.calculateTotals();
      },
      deep: true
    }
  }
};
